import { SVGProps } from 'react';

export default function Order2(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '20'}
      height={props.height || '20'}
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2313_3033)">
        <path
          d="M15 10C14.122 10.001 13.2592 9.77056 12.4987 9.33183C11.7381 8.89311 11.1067 8.26163 10.668 7.50106C10.2294 6.7405 9.99894 5.87772 10 4.99971C10.0011 4.1217 10.2336 3.25949 10.6742 2.5H3.535L3.5 2.20667C3.42818 1.59883 3.13588 1.03846 2.67849 0.631753C2.2211 0.225045 1.6304 0.000260697 1.01833 0L0.833333 0C0.61232 0 0.400358 0.0877974 0.244078 0.244078C0.0877974 0.400358 0 0.61232 0 0.833333C0 1.05435 0.0877974 1.26631 0.244078 1.42259C0.400358 1.57887 0.61232 1.66667 0.833333 1.66667H1.01833C1.22244 1.66669 1.41945 1.74163 1.57198 1.87726C1.72451 2.0129 1.82195 2.19979 1.84583 2.4025L2.9925 12.1525C3.11154 13.1665 3.59873 14.1015 4.36159 14.78C5.12445 15.4585 6.10988 15.8334 7.13083 15.8333H15.8333C16.0543 15.8333 16.2663 15.7455 16.4226 15.5893C16.5789 15.433 16.6667 15.221 16.6667 15C16.6667 14.779 16.5789 14.567 16.4226 14.4107C16.2663 14.2545 16.0543 14.1667 15.8333 14.1667H7.13083C6.6149 14.1654 6.11201 14.0045 5.69112 13.7061C5.27023 13.4077 4.95198 12.9864 4.78 12.5H14.7142C15.6911 12.5001 16.6369 12.1569 17.3865 11.5304C18.1361 10.9039 18.6417 10.0339 18.815 9.0725L19.0133 7.97333C18.5498 8.6018 17.9451 9.11262 17.248 9.46464C16.5509 9.81665 15.7809 10 15 10Z"
          fill={props.fill || 'black'}
        />
        <path
          d="M5.83317 20.0003C6.75365 20.0003 7.49984 19.2541 7.49984 18.3337C7.49984 17.4132 6.75365 16.667 5.83317 16.667C4.9127 16.667 4.1665 17.4132 4.1665 18.3337C4.1665 19.2541 4.9127 20.0003 5.83317 20.0003Z"
          fill={props.fill || 'black'}
        />
        <path
          d="M14.1667 20.0003C15.0871 20.0003 15.8333 19.2541 15.8333 18.3337C15.8333 17.4132 15.0871 16.667 14.1667 16.667C13.2462 16.667 12.5 17.4132 12.5 18.3337C12.5 19.2541 13.2462 20.0003 14.1667 20.0003Z"
          fill={props.fill || 'black'}
        />
        <path
          d="M13.111 7.45522C13.2543 7.61002 13.4275 7.73414 13.6202 7.82008C13.8128 7.90602 14.0209 7.95199 14.2318 7.95522H14.2593C14.466 7.95591 14.6708 7.91552 14.8618 7.83641C15.0528 7.7573 15.2261 7.64105 15.3718 7.49439L18.9318 3.93439C19.0888 3.77769 19.1772 3.56503 19.1774 3.34319C19.1777 3.12135 19.0898 2.90851 18.9331 2.75147C18.7764 2.59444 18.5637 2.50609 18.3419 2.50586C18.12 2.50563 17.9072 2.59353 17.7501 2.75022L14.261 6.24522L13.2326 5.14189C13.0817 4.98022 12.8727 4.88514 12.6516 4.87756C12.4306 4.86998 12.2156 4.95052 12.0539 5.10147C11.8922 5.25243 11.7971 5.46142 11.7896 5.68248C11.782 5.90354 11.8625 6.11855 12.0135 6.28022L13.111 7.45522Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2313_3033">
          <rect width={props.width || '20'} height={props.height || '20'} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
